var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-users"},[_c('h2',[_vm._v("ユーザー検索")]),_c('UserList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }